import { gql } from "@apollo/client";

export const GENERATOR_OTP = gql`
  query GeneratorOtp($input: InputGeneratorOtp!) {
    GeneratorOtp(input: $input) {
      id
    }
  }
`;
